// Money helpers — amounts are integer øre everywhere except at the display layer.

/** Format integer øre as Danish kroner, e.g. 950000 -> "9.500,00 kr.". */
export function formatOere(oere: number): string {
  const sign = oere < 0 ? '-' : ''
  const abs = Math.abs(oere)
  const kr = Math.floor(abs / 100)
  const rest = String(abs % 100).padStart(2, '0')
  const grouped = String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${sign}${grouped},${rest} kr.`
}

/**
 * Parse a Danish kroner string ("9.500", "9.500,5", "9500,00") to integer øre
 * using string arithmetic only (no floats). Returns null when invalid.
 */
export function parseKrToOere(input: string): number | null {
  const s = input.trim().replace(/\s/g, '').replace(/\./g, '')
  const m = /^(\d+)(?:,(\d{1,2}))?$/.exec(s)
  if (!m) return null
  const kr = Number(m[1])
  const oere = Number((m[2] ?? '').padEnd(2, '0') || '0')
  const total = kr * 100 + oere
  return Number.isSafeInteger(total) ? total : null
}
